import { MatDialog } from '@angular/material';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { isString } from 'lodash';
import english from '../../../../i18n/en.json';
import spanish from '../../../../i18n/es.json';
import portuguese from '../../../../i18n/pt.json';
import { FormDetailsComponent } from './form-details/form-details.component';
var TabFormsComponent = /** @class */ (function () {
    function TabFormsComponent(data, fuseTranslationLoaderService, matDialog) {
        this.data = data;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.matDialog = matDialog;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.allForms = data.maintenance.formAnswers;
        this.forms = this.allForms;
    }
    TabFormsComponent.prototype.openForm = function (questionAnswers, formTitle) {
        this.matDialog.open(FormDetailsComponent, {
            panelClass: 'dialog-edit-maintenance',
            data: {
                questionAnswers: questionAnswers,
                formTitle: formTitle
            }
        });
    };
    TabFormsComponent.prototype.filterForms = function (value) {
        this.forms = value
            ? this.allForms.filter(function (_a) {
                var name = _a.name;
                return isString(name) && name.toUpperCase().includes(value.toUpperCase());
            })
            : this.allForms;
    };
    return TabFormsComponent;
}());
export { TabFormsComponent };
